<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/aeRBsr/tc-custom/9781504090094.jpg?1707506383328" alt="This image is the cover for the book Murder in Copper, Deputy Allred & Apache Officer Victor"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder in Copper, Deputy Allred & Apache Officer Victor
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A copper theft investigation puts Arizona and the Apache Tribal Police on the trail of a deadly conspiracy in this borderland mystery thriller.</b></p><p> Sgt. Bren Allred has seen all manner of criminality in beautiful Graham County, Arizona. He has managed to keep the worst of it from his wife, Monica, who is having a troubled pregnancy. But it will be difficult to keep the devils at bay as a new kind of trouble erupts across the region . . . </p> When deputies Sanchez and Haley go undercover to investigate a rash of copper theft, they unwittingly stumble across a shadowy spy network. Meanwhile, Apache Police Sgt. Al Victor is confronted by a murder case involving a diplomat as he grapples with the ever-present problem of alcohol on the reservation.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virgil Alexander
      </h2>
      
      <p class="authorDescription body article">Virgil Alexander is an award-winning author who bases his writing in the American Southwest, where he has lived and worked his entire life. In addition to his five-book Deputy Allred &amp; Apache Officer Victor series, Alexander has written about Western history for numerous magazines, newspapers, webpages, museums, and the Arizona History Convention. He was also the co-editor of <I>Miami: A History of the Miami Area, Arizona</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1d49562a